import { fetchAtom } from "data/api/useFetch"
import { useAtomValue } from "jotai"

const dashboardsAtom = fetchAtom("/v1/dashboards")

export function useDashboards() {
  const { ok } = useAtomValue(dashboardsAtom)

  return ok ? ok.data : []
}
